module.exports = __webpack_public_path__ + "static/img/xj1-2.79adf47.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xj1-2.png
// module id = 726
// module chunks = 0